import { PaletteColor } from '@mui/material'

declare module '@mui/material/styles' {
	interface Palette {
		gameTeeterTotter: Palette['primary']
	}

	interface PaletteOptions {
		gameTeeterTotter?: PaletteOptions['primary']
	}
}

declare module '@mui/material/Alert' {
	interface AlertPropsColorOverrides {
		gameTeeterTotter: true
	}
}

export const gameTeeterTotterColor = {
	main: '#FF437B',
	light: '#FFDDE7',
} as PaletteColor
